import { FunctionComponent } from "react";
import {
  Box,
  Stack,
  Checkbox,
  FormControlLabel,
  Typography,
  CircularProgress,
} from "@mui/material";
import { IProps } from "./IProps";
import { AccessQuery } from "../../types/AccessQuery";
import { AccessChart } from "../../types/AccessChart";
import { AccessTable } from "../../types/AccessTable";

export const AccessDashboard: FunctionComponent<IProps> = (props) => {
  let loading: boolean = props.isLoading!;

  const isAccessQuery = (object: any): object is AccessQuery => {
    return "queryId" in object;
  };

  const isAccessChart = (object: any): object is AccessChart => {
    return "chartId" in object;
  };

  const isAccessTable = (object: any): object is AccessTable => {
    return "dashboardTableID" in object;
  };

  const StackControls = () => {
    return (
      <>
        {loading ? (
          <CircularProgress />
        ) : (
          <Stack direction="column">
            {props.items.map((item, index) => {
              if (isAccessQuery(item)) {
                return (
                  <FormControlLabel
                    key={`query-${item.queryId}`}
                    disabled={props.disabled && !item.isSelected}
                    control={
                      <Checkbox
                        defaultChecked={item.isSelected}
                        value={item.queryId.toString()}
                        name="query-checkbox"
                        onChange={(event) => {
                          props.onChange!(event);
                          item.isSelected = event.target.checked;
                        }}
                      />
                    }
                    label={item.description}
                  />
                );
              } else if (isAccessChart(item)) {
                return (
                  <FormControlLabel
                    key={`chart-${item.chartId}`}
                    disabled={props.disabled && !item.isSelected}
                    control={
                      <Checkbox
                        defaultChecked={item.isSelected}
                        value={item.chartId.toString()}
                        name="chart-checkbox"
                        onChange={(event) => {
                          props.onChange!(event);
                          item.isSelected = event.target.checked;
                        }}
                      />
                    }
                    label={item.description}
                  />
                );
              } else if (isAccessTable(item)) {
                return (
                  <FormControlLabel
                    key={`table-${item.dashboardTableID}`}
                    disabled={props.disabled && !item.isSelected}
                    control={
                      <Checkbox
                        defaultChecked={item.isSelected}
                        value={item.dashboardTableID}
                        name="table-checkbox"
                        onChange={(event) => {
                          props.onChange!(event);
                          item.isSelected = event.target.checked;
                        }}
                      />
                    }
                    label={item.dashboardTableDescription}
                  />
                );
              }
              return null;
            })}
          </Stack>
        )}
      </>
    );
  };

  return (
    <Box sx={{ pl: 4 }}>
      {props.items.length ? (
        <StackControls />
      ) : (
        <Typography>No items available</Typography>
      )}
    </Box>
  );
};
